var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAndroidazure(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -18.713,
    y1: 1.674,
    x2: -19.201,
    y2: 0.71,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#114a8b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0669bc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -13.307,
    y1: 1.225,
    x2: -13.388,
    y2: 1.199,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopOpacity: 0.302
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.071,
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.321,
    stopOpacity: 0.102
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.623,
    stopOpacity: 0.051
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -18.181,
    y1: 1.702,
    x2: -17.672,
    y2: 0.748,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3ccbf4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2892df"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_623",
    "data-name": "Group 623",
    transform: "translate(-753 -416)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_621",
    "data-name": "Group 621",
    transform: "translate(-2 108)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_619",
    "data-name": "Group 619",
    transform: "translate(755 308)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_295",
    "data-name": "Rectangle 295",
    width: 76,
    height: 76,
    rx: 3,
    fill: "#efefef"
  }), /*#__PURE__*/React.createElement("g", {
    id: "android",
    transform: "translate(9.012 5.843)",
    opacity: 0.764
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_473",
    "data-name": "Group 473",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2239",
    "data-name": "Path 2239",
    d: "M113.843,155.433V184.8c0,2.293,1.377,4.092,3.737,4.092h3.081a2.268,2.268,0,0,0-.343,1.16v8.317a4.335,4.335,0,0,0,8.634,0V190.05a2.137,2.137,0,0,0-.519-1.16h7.516a2.136,2.136,0,0,0-.521,1.16v8.317a4.335,4.335,0,0,0,8.634,0V190.05a2.269,2.269,0,0,0-.342-1.16h3.086c2.36,0,3.732-1.8,3.732-4.092V155.433H113.843Z",
    transform: "translate(-103.489 -137.429)",
    fill: "#57c927"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2240",
    "data-name": "Path 2240",
    d: "M31.745,158.977a4.238,4.238,0,0,0-4.317,3.936v16.853a4.335,4.335,0,0,0,8.634,0V162.914A4.239,4.239,0,0,0,31.745,158.977Z",
    transform: "translate(-27.428 -139.005)",
    fill: "#57c927"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2241",
    "data-name": "Path 2241",
    d: "M139.627,5.674l.753-1.105.754-1.092,1.68-2.455a.641.641,0,0,0-.187-.91.678.678,0,0,0-.931.183l-2.565,3.737-.772,1.126a23.143,23.143,0,0,0-16.047,0l-.767-1.125-.759-1.1L118.984.3a.689.689,0,0,0-.938-.183.648.648,0,0,0-.188.91l1.679,2.456.754,1.093.758,1.1c-5.724,2.6-9.6,7.739-9.6,13.136H149.22C149.22,13.414,145.348,8.27,139.627,5.674Zm-17.385,7.9a1.969,1.969,0,1,1,2.024-1.971A2,2,0,0,1,122.242,13.571Zm16.189,0a1.969,1.969,0,1,1,2.024-1.971A2,2,0,0,1,138.431,13.571Z",
    transform: "translate(-101.635 0)",
    fill: "#57c927"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2242",
    "data-name": "Path 2242",
    d: "M31.937,197.866c-1.683,0-3.43-1.588-4.509-4.105v16.1a4.335,4.335,0,0,0,8.634,0V194.6C34.983,196.623,33.422,197.866,31.937,197.866Z",
    transform: "translate(-27.428 -169.243)",
    fill: "#1cb71c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2243",
    "data-name": "Path 2243",
    d: "M415.745,158.977a4.238,4.238,0,0,0-4.317,3.936v16.853a4.335,4.335,0,0,0,8.634,0V162.914A4.239,4.239,0,0,0,415.745,158.977Z",
    transform: "translate(-361.142 -139.005)",
    fill: "#57c927"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_474",
    "data-name": "Group 474",
    transform: "translate(9.817 9.575)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2244",
    "data-name": "Path 2244",
    d: "M415.937,197.866c-1.683,0-3.43-1.588-4.509-4.105v16.1a4.335,4.335,0,0,0,8.634,0V194.6C418.983,196.623,417.422,197.866,415.937,197.866Z",
    transform: "translate(-370.959 -178.481)",
    fill: "#1cb71c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2245",
    "data-name": "Path 2245",
    d: "M133.775,164.008c-8.537,0-16.189-.988-18.347-2.389v28.529c0,2.293,1.377,4.092,3.737,4.092h3.081a2.268,2.268,0,0,0-.343,1.16v8.317a4.335,4.335,0,0,0,8.634,0V195.4a2.136,2.136,0,0,0-.519-1.16h7.516a2.136,2.136,0,0,0-.521,1.16v8.317a4.335,4.335,0,0,0,8.634,0V195.4a2.269,2.269,0,0,0-.342-1.16h3.086c2.36,0,3.732-1.8,3.732-4.092v-28.53C149.964,163.019,142.313,164.008,133.775,164.008Z",
    transform: "translate(-114.892 -152.354)",
    fill: "#1cb71c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2246",
    "data-name": "Path 2246",
    d: "M140.455,73a2.025,2.025,0,0,1-4.049,0,1.929,1.929,0,0,1,.693-1.472,41.738,41.738,0,0,0-13.525,0A1.925,1.925,0,0,1,124.267,73a2.025,2.025,0,0,1-4.048,0,1.925,1.925,0,0,1,.168-.784,24.477,24.477,0,0,0-8.114,3.617,14.321,14.321,0,0,0-.821,4.379H149.22a14.33,14.33,0,0,0-.82-4.376,24.432,24.432,0,0,0-8.112-3.621A1.956,1.956,0,0,1,140.455,73Z",
    transform: "translate(-111.452 -70.977)",
    fill: "#1cb71c"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2247",
    "data-name": "Path 2247",
    d: "M133.016,238.546c-6.97,0-13.45-1.434-17.588-3.785v18.662c0,2.293,1.32,4.093,3.583,4.093h2.954a2.337,2.337,0,0,0-.329,1.16v8.317a4.144,4.144,0,0,0,8.277,0v-8.317a2.177,2.177,0,0,0-.5-1.16h7.205a2.176,2.176,0,0,0-.5,1.16v8.317a4.144,4.144,0,0,0,8.277,0v-8.317a2.338,2.338,0,0,0-.328-1.16h2.958c2.263,0,3.578-1.8,3.578-4.093V234.761C146.466,237.113,139.986,238.546,133.016,238.546Z",
    transform: "translate(-103.556 -206.055)",
    fill: "#049e42"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_622",
    "data-name": "Group 622",
    transform: "translate(67.522 319.913)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2410",
    "data-name": "Path 2410",
    d: "M10.99,6.543h6.2L10.754,25.617a.989.989,0,0,1-.937.673H4.991a.987.987,0,0,1-.935-1.3l6-17.771a.989.989,0,0,1,.937-.673Z",
    transform: "translate(708.997 120.544)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2411",
    "data-name": "Path 2411",
    d: "M38.261,60.261H28.427a.455.455,0,0,0-.311.788l6.319,5.9a.993.993,0,0,0,.678.267h5.568Z",
    transform: "translate(690.737 79.619)",
    fill: "#0078d4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2412",
    "data-name": "Path 2412",
    d: "M10.994,6.544a.981.981,0,0,0-.939.686L4.067,24.971A.986.986,0,0,0,5,26.29H9.948a1.058,1.058,0,0,0,.812-.691l1.194-3.519,4.265,3.978a1.009,1.009,0,0,0,.635.231H22.4l-2.433-6.953-7.093,0L17.217,6.544Z",
    transform: "translate(708.993 120.543)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2413",
    "data-name": "Path 2413",
    d: "M41.495,7.216a.987.987,0,0,0-.935-.672H33.648a.987.987,0,0,1,.935.672l6,17.772a.987.987,0,0,1-.935,1.3h6.911a.987.987,0,0,0,.935-1.3Z",
    transform: "translate(686.412 120.543)",
    fill: "url(#linear-gradient-3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAndroidazure);
export default __webpack_public_path__ + "static/media/androidazure.119b60a5e688f839547c34d0b7aa3269.svg";
export { ForwardRef as ReactComponent };